import { HasRunbooksInGit } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { BranchAwareRedirect } from "./BranchAwareRedirect";
export function RunbooksBranchAwareRedirect({ children }: React.PropsWithChildren<{}>) {
    return <BranchAwareRedirect condition={(project) => HasRunbooksInGit(project.PersistenceSettings)}>{children}</BranchAwareRedirect>;
}
